import { hasAccess } from './modules';

export const permOf = (user, view) => ({
  canRead:   hasAccess(user, view, 'Lectura'),
  canEdit:   hasAccess(user, view, 'Edición'),
  canDelete: hasAccess(user, view, 'Eliminación'),
});
